import React, {Component} from 'react';

class SimpleErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorDetail: '' };
  }

  // componentDidCatch(error, info) {
  //   this.setState({ hasError: true });
  //   this.setState({ errorDetail: error });
  // }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      errorDetail: error,
    };
  }

  render() {
    if (this.state.hasError) {
      return <p>{this.state.errorDetail.toString()}</p>;
    }
    return this.props.children;
  }
}

SimpleErrorBoundary.propTypes = {};

export default SimpleErrorBoundary;



// WEBPACK FOOTER //
// ./src/components/SimpleErrorBoundary.js